import { Route } from 'vue-router';

const authRoutes = [
    {
        name: 'AppLogin',
        path: '/auth/app_callback',
        props: (route: Route) => ({ jwt: route.query.jwt }),
        // beforeEnter: (to: Route, from: Route, next: any) => {
        //     productionGuard(to, from, next);
        // },
        component: () => import (/* webpackChunkName: "auth" */ '../views/auth/AppCallback.vue'),
    }
];

export default authRoutes